import React from 'react';
import { BOTTOM_INDENTS, COLORS, validateDebounce, VALIDATION_RULES } from '@constants';
import { Icon, Input, Typography } from '@ui';
import { Form } from 'antd';
import { FIELD_NAMES } from '../../../../../constants';
import { useMeasurementIdModal } from '../../hooks';
import PropertyIdSection from '../PropertyIdSection';
import { QuestionIcon } from '../QuestionIcon';
import { StyledCard } from './styled';

const MeasurementId = () => {
    const { showMeasurementIdModal } = useMeasurementIdModal();
    const form = Form.useFormInstance();

    const handleMeasurementIdModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        showMeasurementIdModal();
    };

    return (
        <StyledCard style={BOTTOM_INDENTS.XL_PLUS}>
            <Typography.Text style={BOTTOM_INDENTS.M} type='body2' color={COLORS.$gray60Black}>
                Enter your store’s Google Analytics Measurement ID
            </Typography.Text>
            <Form.Item
                name={FIELD_NAMES.GOOGLE_ANALYTICS_MEASUREMENT_ID}
                rules={[
                    (formInstance) => {
                        return formInstance.getFieldValue(FIELD_NAMES.GOOGLE_ANALYTICS)
                            ? VALIDATION_RULES.REQUIRED[0]
                            : undefined;
                    },
                    (formInstance) => {
                        return formInstance.getFieldValue(FIELD_NAMES.GOOGLE_ANALYTICS)
                            ? VALIDATION_RULES.MEASUREMENT_ID[0]
                            : undefined;
                    }
                ]}
                validateDebounce={validateDebounce}
                onBlur={() =>
                    form.setFieldValue(
                        FIELD_NAMES.GOOGLE_ANALYTICS_MEASUREMENT_ID,
                        form.getFieldValue(FIELD_NAMES.GOOGLE_ANALYTICS_MEASUREMENT_ID)?.trim()
                    )
                }
            >
                <Input
                    data-e2e='tracking_measurement-id_input'
                    label='G-XXXXXXXXXX'
                    suffix={
                        <Icon
                            onClick={handleMeasurementIdModal}
                            component={() => <QuestionIcon data-e2e='tracking_measurement-id-hint_icon' />}
                        />
                    }
                />
            </Form.Item>
            <PropertyIdSection />
        </StyledCard>
    );
};

export default MeasurementId;
